const CommentValidation = (values) => {
    const errors = {};

    if(!values.message || values.message === ""){
        errors.message = "Le commentaire est obligatoire"
    }
    return errors
};

export default CommentValidation;